import React from "react";
import { Heart, Phone, ArrowRight } from "lucide-react";

const VolunteerSection = () => {
  return (
    <section id="volunteer" className="bg-[color:var(--hc-cream-2)]" data-testid="volunteer-section">
      <div className="container-hc py-20 md:py-28">
        <div className="max-w-3xl">
          <div className="hc-chip chip-coral" data-testid="volunteer-chip">
            <Heart size={14} />
            Become a Volunteer
          </div>

          <h2 className="font-serif-display mt-7 text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] text-[color:var(--hc-navy)]">
            For kindhearted souls who love{" "}
            <span className="italic text-[color:var(--hc-coral)]">making people smile.</span>
          </h2>

          <p className="mt-7 text-lg text-[color:var(--hc-navy)]/80 leading-relaxed">
            If you share our commitment to dignity, respect, and joy — and you believe that
            every life is worth celebrating — we'd be honored to have you spend some time
            with our residents.
          </p>

          <p className="mt-5 text-lg text-[color:var(--hc-navy)]/75 leading-relaxed">
            Volunteering at Hillcrest is a beautiful way to give back while forming meaningful
            connections with people whose stories will stay with you for a lifetime. Your time
            and talents will make a lasting difference — we promise.
          </p>

          <div className="mt-9 bg-white rounded-2xl p-6 md:p-7 border border-[color:var(--hc-navy)]/8 shadow-sm">
            <div className="text-[10px] font-bold tracking-[0.25em] text-[color:var(--hc-coral)]">
              INTERESTED?
            </div>
            <div className="mt-2 font-serif-display text-2xl text-[color:var(--hc-navy)]">
              Reach out to our director, Jana Pate.
            </div>
            <p className="mt-3 text-sm text-[color:var(--hc-navy)]/65 leading-relaxed">
              A friendly phone call is the best place to start. Jana would love to hear what
              you'd enjoy sharing and help find the right fit.
            </p>

            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <a
                href="tel:9362750222"
                className="inline-flex items-center justify-center gap-2 bg-[#2d7a4f] hover:bg-[#246340] text-white px-5 py-3 rounded-full font-semibold transition-colors"
                data-testid="volunteer-call-btn"
              >
                <Phone size={16} /> Call (936) 275-0222
              </a>
              <a
                href="#tour"
                className="inline-flex items-center justify-center gap-2 bg-white border border-[color:var(--hc-navy)]/15 text-[color:var(--hc-navy)] px-5 py-3 rounded-full font-semibold hover:bg-[color:var(--hc-cream)] transition-colors"
                data-testid="volunteer-visit-btn"
              >
                Visit Us <ArrowRight size={16} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VolunteerSection;
